import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgMaterialModule } from '@principle-theorem/ng-material';
import { NgPrincipleModule } from '@principle-theorem/ng-principle';
import { NgPrincipleBridgeCloudModule } from '@principle-theorem/ng-principle-bridge-cloud';
import {
  NgPrincipleSharedModule,
  PracticeAccSettingsComponent,
  PracticeMohSettingsComponent,
  PractitionerSelectorComponent,
} from '@principle-theorem/ng-principle-shared';
import {
  AttachmentsComponent,
  NgSharedModule,
} from '@principle-theorem/ng-shared';
import { NgTyroModule } from '@principle-theorem/ng-tyro';
import { VerifoneService } from '@principle-theorem/ng-payments';
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { GeneralPracticeComponent } from './general-practice/general-practice.component';
import { AddPublicKeyDialogComponent } from './practice-integrations/practice-bridge-settings/add-public-key-dialog/add-public-key-dialog.component';
import { EditBridgeDeviceDialogComponent } from './practice-integrations/practice-bridge-settings/edit-bridge-device-dialog/edit-bridge-device-dialog.component';
import { PracticeBridgeSettingsComponent } from './practice-integrations/practice-bridge-settings/practice-bridge-settings.component';
import { ViewBridgeLogsDialogComponent } from './practice-integrations/practice-bridge-settings/view-bridge-logs-dialog/view-bridge-logs-dialog.component';
import { HicapsCustomRequestComponent } from './practice-integrations/practice-hicaps-connect-settings/hicaps-custom-request/hicaps-custom-request.component';
import { PracticeHicapsConnectSettingsComponent } from './practice-integrations/practice-hicaps-connect-settings/practice-hicaps-connect-settings.component';
import { PracticeHicapsConnectTerminalsComponent } from './practice-integrations/practice-hicaps-connect-settings/practice-hicaps-connect-terminals/practice-hicaps-connect-terminals.component';
import { PracticeHicapsConnectV2SettingsComponent } from './practice-integrations/practice-hicaps-connect-settings/practice-hicaps-connect-v2-settings/practice-hicaps-connect-v2-settings.component';
import { PracticeIntegrationsComponent } from './practice-integrations/practice-integrations.component';
import { EditSmartpayTerminalDialogComponent } from './practice-integrations/practice-smartpay-settings/edit-smartpay-terminal-dialog/edit-smartpay-terminal-dialog.component';
import { PairSmartpayTerminalDialogComponent } from './practice-integrations/practice-smartpay-settings/pair-smartpay-terminal-dialog/pair-smartpay-terminal-dialog.component';
import { PracticeSmartpaySettingsComponent } from './practice-integrations/practice-smartpay-settings/practice-smartpay-settings.component';
import { PracticeSmartpayTerminalsComponent } from './practice-integrations/practice-smartpay-settings/practice-smartpay-terminals/practice-smartpay-terminals.component';
import { SmartpayConfigurationComponent } from './practice-integrations/practice-smartpay-settings/smartpay-configuration/smartpay-configuration.component';
import { EditVerifoneTerminalDialogComponent } from './practice-integrations/practice-verifone-settings/edit-verifone-terminal-dialog/edit-verifone-terminal-dialog.component';
import { PracticeVerifoneSettingsComponent } from './practice-integrations/practice-verifone-settings/practice-verifone-settings.component';
import { PracticeVerifoneTerminalsComponent } from './practice-integrations/practice-verifone-settings/practice-verifone-terminals/practice-verifone-terminals.component';
import { VerifoneConfigurationComponent } from './practice-integrations/practice-verifone-settings/verifone-configuration/verifone-configuration.component';
import { EditTyroTerminalDialogComponent } from './practice-integrations/practice-tyro-settings/edit-tyro-terminal-dialog/edit-tyro-terminal-dialog.component';
import { PairTyroTerminalDialogComponent } from './practice-integrations/practice-tyro-settings/pair-tyro-terminal-dialog/pair-tyro-terminal-dialog.component';
import { PairTyroTerminalService } from './practice-integrations/practice-tyro-settings/pair-tyro-terminal-dialog/pair-tyro-terminal.service';
import { PracticeTyroSettingsComponent } from './practice-integrations/practice-tyro-settings/practice-tyro-settings.component';
import { PracticeTyroTerminalsComponent } from './practice-integrations/practice-tyro-settings/practice-tyro-terminals/practice-tyro-terminals.component';
import { TyroConfigurationComponent } from './practice-integrations/practice-tyro-settings/tyro-configuration/tyro-configuration.component';
import { TyroLogsDialogComponent } from './practice-integrations/practice-tyro-settings/tyro-logs-dialog/tyro-logs-dialog.component';
import { EditPracticeOpeningHoursComponent } from './practice-opening-hours/edit-practice-opening-hours/edit-practice-opening-hours.component';
import { PracticeOpeningHoursComponent } from './practice-opening-hours/practice-opening-hours.component';
import { PracticeTagManagementComponent } from './practice-tag-management/practice-tag-management.component';
import { PracticeHeidiSettingsComponent } from './practice-integrations/practice-heidi-settings/practice-heidi-settings.component';

@NgModule({
  imports: [
    NgMaterialModule,
    NgSharedModule,
    NgTyroModule,
    NgPrincipleModule,
    ReactiveFormsModule,
    NgPrincipleSharedModule,
    NgPrincipleBridgeCloudModule,
    MonacoEditorModule,
    NgJsonEditorModule,
    PractitionerSelectorComponent,
    PracticeMohSettingsComponent,
    PracticeHeidiSettingsComponent,
    PracticeAccSettingsComponent,
    AttachmentsComponent,
    PracticeHicapsConnectV2SettingsComponent,
  ],
  declarations: [
    GeneralPracticeComponent,
    PracticeOpeningHoursComponent,
    EditPracticeOpeningHoursComponent,
    PracticeTagManagementComponent,
    PracticeTyroSettingsComponent,
    EditTyroTerminalDialogComponent,
    PairTyroTerminalDialogComponent,
    TyroLogsDialogComponent,
    PracticeIntegrationsComponent,
    PracticeIntegrationsComponent,
    TyroConfigurationComponent,
    PracticeBridgeSettingsComponent,
    EditBridgeDeviceDialogComponent,
    AddPublicKeyDialogComponent,
    PracticeHicapsConnectSettingsComponent,
    PracticeHicapsConnectTerminalsComponent,
    HicapsCustomRequestComponent,
    ViewBridgeLogsDialogComponent,
    PracticeTyroTerminalsComponent,
    PracticeSmartpaySettingsComponent,
    EditSmartpayTerminalDialogComponent,
    PairSmartpayTerminalDialogComponent,
    SmartpayConfigurationComponent,
    PracticeSmartpayTerminalsComponent,
    PracticeVerifoneSettingsComponent,
    EditVerifoneTerminalDialogComponent,
    VerifoneConfigurationComponent,
    PracticeVerifoneTerminalsComponent,
  ],
  providers: [PairTyroTerminalService, VerifoneService],
})
export class PracticesModule {}
